// import axios from 'axios';
import React, { useState } from 'react';
import '../../CSS/Login/login.scss';
import getUrl from '../../Utility/GetUrl';
import { postData } from '../../Utility/GlobalService';


const Login = ()=> {

    const [username,setUsername] = useState("");
    const [password,setPassword] = useState("");
    const handleFormSubmit = (event)=>{
        event.preventDefault();
        postUserCredentials();
        resetForm();
        
    }
    const postUserCredentials = async()=>{
        const user = {
            username,
            password
        }
        const response = await postData(`${getUrl()}/auth/signin`,user,null,true);
        if(response) window.location.pathname = "/dashboard";
        // console.log(response);
    }
    const resetForm = ()=>{
        setUsername("");
        setPassword("");
    }
    const onUsernameChange = event => {
        setUsername(event.target.value);
        // console.log(event.target.value);
    };
    const onPasswordChange = event => {
        setPassword(event.target.value);
        // console.log(event.target.value);
    };
return (
  <div className="login-page">
    <div 
    className="container pt-5">
      <div className="main-container row pt-5">
        <div className="col-md-3"></div>
        <div className="col-md-6">
          <h4>Please Login! </h4>
        </div>
        <div className="col-md-3"></div>
      </div>
      <div className="row">
        <div className="col-md-3"></div>
        <div className="col-md-6">
          <form onSubmit={handleFormSubmit}>
            <div class="form-group mt-3">
              <label>Username</label>
              <input
                onChange={onUsernameChange}
                value={username}
                type="text"
                class="form-control form-input"
                placeholder="Enter Username"
              />
            </div>
            <div class="form-group mt-3">
              <label>Password</label>
              <input
                onChange={onPasswordChange}
                value={password}
                type="password"
                class="form-input form-control"
                placeholder="Enter User Password"
              />
            </div>
            <div class="form-group mt-5">
              {/* <input
                className="login-btn btn btn-primary btn-sm btn-block"
                type="submit"
                value="Login"
              /> */}
              <button
                type="submit"
                className="login-btn btn btn-primary btn-sm btn-block"
              >
                Login
              </button>
            </div>
          </form>
        </div>
        <div className="col-md-3"></div>
      </div>
    </div>
  </div>
);
}

export default Login;